import { motion } from "framer-motion";
import { Home, TrendingDown, Percent, Landmark, FileText, ShieldCheck, ArrowRight } from "lucide-react";
import { useI18n } from "../i18n";
import { CONTACT } from "../lib/contact";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { trackWhatsApp } from "../lib/analytics";

const ICONS = [Home, TrendingDown, Percent, Landmark, FileText, ShieldCheck];

const Guides = () => {
  const { t } = useI18n();
  const g = t.guides;

  return (
    <section id="guia" data-testid="guides-section" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl mb-16"
        >
          <div className="text-xs tracking-[0.25em] uppercase text-[#A60056] font-semibold mb-4">{g.label}</div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl text-white mb-5 text-balance">{g.title}</h2>
          <p className="text-white/60 text-base sm:text-lg leading-relaxed">{g.subtitle}</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {g.items.map((it, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.article
                key={it.t}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.06 }}
                className="group p-7 rounded-2xl bg-[#0A0A0C] border border-white/10 hover:border-[#A60056]/40 transition-all duration-300 hover:-translate-y-1"
                data-testid={`guide-${i}`}
              >
                <div className="w-11 h-11 rounded-xl bg-[#A60056]/12 border border-[#A60056]/25 flex items-center justify-center mb-5 group-hover:bg-[#A60056]/20 transition-colors">
                  <Icon className="w-5 h-5 text-[#A60056]" />
                </div>
                <h3 className="text-lg font-medium text-white mb-3">{it.t}</h3>
                <p className="text-sm text-white/70 leading-relaxed">{it.d}</p>
              </motion.article>
            );
          })}
        </div>

        <div className="mt-12">
          <a
            href={CONTACT.whatsapp()}
            target="_blank"
            rel="noreferrer"
            onClick={() => trackWhatsApp("guides")}
            className="btn-whatsapp"
            data-testid="guides-cta"
          >
            <WhatsAppIcon className="w-4 h-4" />
            {g.cta}
          </a>
        </div>

        <div className="mt-14 pt-10 border-t border-white/10">
          <div className="text-xs uppercase tracking-[0.2em] text-white/40 mb-5">{g.readMore}</div>
          <div className="grid sm:grid-cols-3 gap-4">
            {g.articles.map((a, i) => (
              <a
                key={a.href}
                href={a.href}
                className="group flex items-start justify-between gap-3 p-5 rounded-xl bg-[#0A0A0C] border border-white/10 hover:border-[#A60056]/40 transition-all duration-300 hover:-translate-y-1"
                data-testid={`article-link-${i}`}
              >
                <span className="text-sm text-white/80 group-hover:text-white leading-snug">{a.t}</span>
                <ArrowRight className="w-4 h-4 text-[#A60056] flex-shrink-0 mt-0.5 group-hover:translate-x-0.5 transition-transform" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Guides;
